import { AxiosResponse } from "axios";
import { Base } from "./bases/base.service";

export default class InstructorService {
  public getInstructorDetail(params: any = {}): Promise<AxiosResponse<any>> {
    return Base().get(`instructor/detail/${params?.id}`, { params });
  }

  public getInstructors(params: any = {}): Promise<AxiosResponse<any>> {
    return Base().get(`instructor/get`, { params });
  }
}
